import React from 'react';
import type { UseFormRegister, UseFormSetValue, UseFormWatch, FieldErrors, UseFormTrigger } from 'react-hook-form';
import { LabelInput } from '@/components/ui/inputs';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { FormLayout } from '@/components/layout';
import type { CreateEmployeeContactData } from '@/schemas/employee/createEmployeeForm';


interface CreateEmployeeContactDataFormProps {
  contactForm: {
    register: UseFormRegister<CreateEmployeeContactData>;
    setValue: UseFormSetValue<CreateEmployeeContactData>;
    watch: UseFormWatch<CreateEmployeeContactData>;
    errors: FieldErrors<CreateEmployeeContactData>;
    trigger: UseFormTrigger<CreateEmployeeContactData>;
  };
  onCancel: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
}

export const CreateEmployeeContactDataForm: React.FC<CreateEmployeeContactDataFormProps> = ({
  contactForm,
  onCancel,
  onNext,
  onPrevious,
}) => {
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
  };

  return (
    <FormLayout onSubmit={handleSubmit} columns={4}>
      <FormLayout.Section title="Datos de contacto del nuevo colaborador">
        <LabelInput 
          label="Correo corporativo" 
          type="email"
          value={contactForm.watch('corporateEmail')} 
          onChange={(value) => contactForm.setValue('corporateEmail', value, { shouldDirty: true })} 
          placeholder="ejemplo@empresa.com"
          required
          color={contactForm.errors.corporateEmail ? 'error' : undefined}
          supportingText={contactForm.errors.corporateEmail?.message}
        />
        <LabelInput 
          label="Correo personal" 
          type="email"
          value={contactForm.watch('personalEmail')} 
          onChange={(value) => contactForm.setValue('personalEmail', value, { shouldDirty: true })} 
          placeholder="ejemplo@correo.com"
          required
          color={contactForm.errors.personalEmail ? 'error' : undefined}
          supportingText={contactForm.errors.personalEmail?.message}
        />
        <LabelInput
          label="Teléfono corporativo"
          type="tel"
          value={contactForm.watch('companyPhoneNumber')} 
          onChange={(value) => contactForm.setValue('companyPhoneNumber', value, { shouldDirty: true })} 
          placeholder="+56912345678"
          color={contactForm.errors.companyPhoneNumber ? 'error' : undefined}
          supportingText={contactForm.errors.companyPhoneNumber?.message}
        />
        <LabelInput 
          label="Teléfono personal" 
          type="tel"
          value={contactForm.watch('personalPhoneNumber')} 
          onChange={(value) => contactForm.setValue('personalPhoneNumber', value, { shouldDirty: true })} 
          placeholder="+56987654321"
          color={contactForm.errors.personalPhoneNumber ? 'error' : undefined}
          supportingText={contactForm.errors.personalPhoneNumber?.message}
        />
      </FormLayout.Section>

      <FormLayout.Footer
        cancelButton={
          <PrimaryButton type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </PrimaryButton>
        }
        secondaryButton={
          onPrevious ? (
            <PrimaryButton type="button" variant="outline" onClick={onPrevious}>
              Anterior
            </PrimaryButton>
          ) : undefined
        }
        primaryButton={
          onNext ? (
            <PrimaryButton 
              type="button" 
              onClick={async () => {
                const isValid = await contactForm.trigger();
                if (isValid) onNext();
              }}
            >
              Siguiente
            </PrimaryButton>
          ) : undefined
        }
      />
    </FormLayout>
  );
};

export default CreateEmployeeContactDataForm;
